import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-79f8ccea"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "fenlei"
};
const _hoisted_2 = {
  class: "panel"
};
const _hoisted_3 = {
  class: "panel-title"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "分类报表", -1));

const _hoisted_5 = {
  style: {
    "text-align": "center"
  }
};

const _hoisted_6 = /*#__PURE__*/_createTextVNode("返回");

const _hoisted_7 = {
  class: "panel-body"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 1
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_12 = {
  class: "paging"
};
const _hoisted_13 = {
  class: "all-sum"
};

const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 占成结果： ");

const _hoisted_15 = /*#__PURE__*/_createTextVNode("  /  赚赔差： ");

const _hoisted_16 = /*#__PURE__*/_createTextVNode("  / 赚取退水： ");

const _hoisted_17 = /*#__PURE__*/_createTextVNode("  /  ");

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "primary-color"
}, "补货结果：", -1));

const _hoisted_19 = /*#__PURE__*/_createTextVNode("  /  ");

const _hoisted_20 = /*#__PURE__*/_createTextVNode("抵扣补货及赚水赔率差后结果");

const _hoisted_21 = /*#__PURE__*/_createTextVNode("抵扣补货及赚水后结果");

const _hoisted_22 = /*#__PURE__*/_createTextVNode("： ");

const _hoisted_23 = /*#__PURE__*/_createTextVNode("  /  ");

const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 与上级交收： ");

const _hoisted_25 = /*#__PURE__*/_createTextVNode("  /  应收下线： ");

const _hoisted_26 = {
  key: 0,
  class: "panel"
};
const _hoisted_27 = {
  class: "panel-title"
};

const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "注单明细", -1));

const _hoisted_29 = /*#__PURE__*/_createTextVNode("返回");

const _hoisted_30 = {
  class: "panel-body"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");

  const _component_el_link = _resolveComponent("el-link");

  const _component_el_table_column = _resolveComponent("el-table-column");

  const _component_el_tooltip = _resolveComponent("el-tooltip");

  const _component_el_table = _resolveComponent("el-table");

  const _component_el_pagination = _resolveComponent("el-pagination");

  const _component_zhudanmingxi = _resolveComponent("zhudanmingxi");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("div", null, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString($props.search_title_info), 1), _createVNode(_component_el_button, {
    style: {
      "float": "right",
      "margin": "3px"
    },
    size: "small",
    onClick: $options.back_search
  }, {
    default: _withCtx(() => [_hoisted_6]),
    _: 1
  }, 8, ["onClick"])])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_table, {
    ref: "tableRef",
    data: $data.data_list,
    border: "",
    size: "small",
    "highlight-current-row": "",
    "header-cell-class-name": "table-header-cell",
    "header-row-class-name": "table-header-row",
    "show-summary": "",
    "summary-method": $options.baobiao_sum,
    "cell-class-name": $options.cellClassName
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "method_name",
      label: "分类",
      align: "center",
      "show-overflow-tooltip": "",
      "min-width": "100"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_link, {
        type: "primary",
        onClick: $event => $options.search_paly(scope.row)
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(scope.row.gname), 1), _withDirectives(_createElementVNode("span", null, "-" + _toDisplayString(scope.row.method_name), 513), [[_vShow, scope.row.method_name != undefined && scope.row.method_name != '']])]),
        _: 2
      }, 1032, ["onClick"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "count",
      label: "笔数",
      align: "center",
      "min-width": "50"
    }), _createVNode(_component_el_table_column, {
      prop: "sum_price",
      label: "总投注额",
      align: "center",
      "min-width": "60"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_link, {
        type: "success",
        onClick: $event => $options.search_detail(scope.row)
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.bet_price), 1)]),
        _: 2
      }, 1032, ["onClick"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "balance",
      label: "有效金额",
      align: "center",
      "min-width": "60"
    }), _createVNode(_component_el_table_column, {
      prop: "win_price",
      label: "会员输赢",
      align: "center",
      "min-width": "60"
    }, {
      default: _withCtx(scope => [_createElementVNode("span", {
        class: _normalizeClass(scope.row.win_price < 0 ? 'redcolor' : '')
      }, _toDisplayString(scope.row.win_price), 3)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "receive_subline",
      label: "应收下线",
      align: "center",
      "min-width": "60"
    }, {
      default: _withCtx(scope => [_createElementVNode("span", {
        class: _normalizeClass(scope.row.receive_subline < 0 ? 'redcolor' : '')
      }, _toDisplayString(scope.row.receive_subline), 3)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "receive_subline",
      label: "实占成数",
      align: "center",
      width: "60"
    }, {
      default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.kuaicai_sup_occupy_lock) + "% ", 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "occupy_balance",
      label: "实占注额",
      align: "center",
      "min-width": "60"
    }), _createVNode(_component_el_table_column, {
      prop: "bonus",
      label: "占货比",
      align: "center",
      width: "50"
    }, {
      default: _withCtx(scope => [$data.total.occupy_balance > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString((scope.row.occupy_balance / $data.total.occupy_balance * 100).toFixed(0)), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_9, "0"))]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "occupy_winlose",
      label: "实占输赢",
      align: "center",
      "min-width": "60"
    }, {
      default: _withCtx(scope => [_createElementVNode("div", null, [_createVNode(_component_el_tooltip, {
        placement: "top"
      }, {
        content: _withCtx(() => [_createTextVNode(" 输赢：" + _toDisplayString(scope.row.user_winlose) + " ", 1), _hoisted_10, scope.row.group_id > 0 && scope.row.group_id < 5 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createTextVNode(" 赚赔：" + _toDisplayString(scope.row.eran - scope.row.trader_eran) + " ", 1), _hoisted_11, _createTextVNode(" 操盘赚赔：" + _toDisplayString(scope.row.trader_eran), 1)], 64)) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(scope.row.occu_winlose), 1)]),
        _: 2
      }, 1024)])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "occu_rebate",
      label: "实占退水",
      align: "center",
      "min-width": "60"
    }), _createVNode(_component_el_table_column, {
      prop: "real_occupy_result",
      label: "实占结果",
      align: "center",
      "min-width": "60"
    }, {
      default: _withCtx(scope => [_createElementVNode("span", {
        class: _normalizeClass(scope.row.real_occupy_result < 0 ? 'redcolor' : '')
      }, _toDisplayString(scope.row.real_occupy_result), 3)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "earn_rebate",
      label: "赚取退水",
      align: "center",
      "min-width": "60"
    }), _ctx.$store.state.userinfo.group_id == 1 ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 0,
      prop: "earn",
      label: "赚取赔差",
      align: "center",
      "min-width": "60"
    })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
      prop: "real_result",
      label: "退水后结果",
      align: "center",
      "min-width": "60"
    }), _createVNode(_component_el_table_column, {
      prop: "cont_sup",
      label: "贡献上级",
      align: "center",
      "min-width": "60"
    }), _createVNode(_component_el_table_column, {
      prop: "receive_supline",
      label: "应付上级",
      align: "center",
      "min-width": "60"
    }, {
      default: _withCtx(scope => [_createElementVNode("span", {
        class: _normalizeClass(scope.row.receive_supline < 0 ? 'redcolor' : '')
      }, _toDisplayString(scope.row.receive_supline), 3)]),
      _: 1
    })]),
    _: 1
  }, 8, ["data", "summary-method", "cell-class-name"]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_pagination, {
    "hide-on-single-page": "",
    small: "",
    onCurrentChange: $options.change_page,
    modelValue: $data.page,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.page = $event),
    "page-size": 40,
    "pager-count": 5,
    total: $data.pagination.total_records * 1,
    layout: "total,prev,pager,next,jumper",
    "prev-text": "上一页",
    "next-text": "下一页"
  }, null, 8, ["onCurrentChange", "modelValue", "total"])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", null, [_hoisted_14, _createElementVNode("span", {
    class: _normalizeClass($data.total.occupy_result < 0 ? 'redcolor' : '')
  }, _toDisplayString($data.total.occupy_result), 3), _ctx.$store.state.userinfo.group_id < 4 && $data.total.own_eran != 0 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_hoisted_15, _createElementVNode("span", {
    class: _normalizeClass($data.total.own_eran < 0 ? 'redcolor' : '')
  }, _toDisplayString($data.total.own_eran), 3)], 64)) : _createCommentVNode("", true), _hoisted_16, _createElementVNode("span", {
    class: _normalizeClass($data.total.earn_rebate < 0 ? 'redcolor' : '')
  }, _toDisplayString($data.total.earn_rebate), 3), $data.autolet[0].result != 0 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_hoisted_17, _hoisted_18, _createVNode(_component_el_link, {
    type: $data.autolet[0].result > 0 ? 'danger' : 'primary',
    onClick: _cache[1] || (_cache[1] = $event => $options.get_buhuo_detail('', '1'))
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.autolet[0].result), 1)]),
    _: 1
  }, 8, ["type"])], 64)) : _createCommentVNode("", true), _hoisted_19, $data.total.group_id == 3 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_hoisted_20], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 3
  }, [_hoisted_21], 64)), _hoisted_22, _createElementVNode("span", {
    class: _normalizeClass($data.total.result < 0 ? 'redcolor' : '')
  }, _toDisplayString($data.total.result * 1), 3), _hoisted_23, $data.total.p_own_eran_result != undefined ? (_openBlock(), _createElementBlock("span", {
    key: 4,
    class: _normalizeClass($data.total.p_own_eran_result < 0 ? 'redcolor' : '')
  }, "赚赔后总结果：" + _toDisplayString($data.total.p_own_eran_result) + "  / ", 3)) : _createCommentVNode("", true), _hoisted_24, _createElementVNode("span", {
    class: _normalizeClass($data.total.total_receive_supline < 0 ? 'redcolor' : '')
  }, _toDisplayString($data.total.total_receive_supline), 3), _hoisted_25, _createElementVNode("span", {
    class: _normalizeClass($data.autolet[0].sum_receive_subline < 0 ? 'redcolor' : '')
  }, _toDisplayString($data.autolet[0].sum_receive_subline), 3)])])])])], 512), [[_vShow, !$data.dialog.visible]]), $data.dialog.visible ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_hoisted_28, _createVNode(_component_el_button, {
    style: {
      "float": "right",
      "margin": "3px"
    },
    size: "small",
    onClick: $options.back_list
  }, {
    default: _withCtx(() => [_hoisted_29]),
    _: 1
  }, 8, ["onClick"])]), _createElementVNode("div", _hoisted_30, [_createVNode(_component_zhudanmingxi, {
    ref: "zhudanmingxi",
    from: '分类报表',
    rowinfo: $data.rowinfo,
    form: $props.form,
    gameClassID: ''
  }, null, 8, ["rowinfo", "form"])])])) : _createCommentVNode("", true)]);
}